import { useToast } from "@chakra-ui/react";
import { parsedOption } from "helpers/parsed/parsedOption";
import {
  ISupplierPurchaseContext,
  ParametersPurchaseOrder,
} from "Interfaces/Providers/SupplierPurchase";
import {
  createContext,
  ReactNode,
  useCallback,
  useEffect,
  useState,
} from "react";
import inventory from "services/inventory";
import purchase from "services/purchase";
import { useImmer } from "use-immer";

import { IInventoryContext } from "../../Interfaces/Providers/Inventory";
interface Auth0ProviderProps {
  children: ReactNode;
}

const SupplierPurchaseProvider = ({ children }: Auth0ProviderProps) => {
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [loadingSkus, setLoadingSkus] = useState(false);
  const [isFirstData, setFirstData] = useState(true);
  const [supplierSelect, setSupplierSect] = useState(null);
  const [query, setQuery] = useState("");

  const [data, updateData] = useImmer<any[]>([]);
  const [suppliers, updateSupplier] = useImmer<any[]>([]);

  //NEW
  const [paramsPurchaseOrderFilter, setParamsPurchaseOrderFilter] =
    useState<ParametersPurchaseOrder>({
      scheduled: true,
      onTime: true,
      lated: true,
    });
  const [idSelectDate, setSelectIds] = useState([]);
  const [idSelectDateSkus, setSelectIdsSkus] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [dataSkus, updateDataSkus] = useImmer<any[]>([]);

  const getData = useCallback(async () => {
    setLoading(true);
    setFirstData(false);
    setSelectIds([]);
    setSelectIdsSkus([]);
    setSelectAll(false);
    const valueStore = JSON.parse(localStorage.getItem("storeUser"));

    purchase
      .getPurchaseOrders(
        paramsPurchaseOrderFilter,
        valueStore?.value,
        supplierSelect.value
      )
      .then((response) => {
        updateData(response.data?.data);
        setLoading(false);
      })
      .catch(() => {
        updateData([]);
        setLoading(false);
      });
  }, [paramsPurchaseOrderFilter, supplierSelect, updateData, setSelectAll]);

  const getSuppliers = useCallback(async () => {
    setLoading(true);
    setFirstData(false);

    purchase
      .getSuppliers()
      .then((response) => {
        updateSupplier(parsedOption(response.data?.data));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [updateSupplier]);

  const postData = useCallback(
    async (obj: any) => {
      setLoading(true);
      setFirstData(false);

      inventory
        .postInventory(obj)
        .then((response) => {
          getData();
          toast({
            title: "Inventário cadastrado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao cadastrar..",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [updateData]
  );

  const putData = useCallback(
    async (obj: any, id: any) => {
      setLoading(true);
      setFirstData(false);

      inventory
        .putInventory(obj, id)
        .then((response) => {
          setLoading(false);
          getData();
          toast({
            title: "Inventário atualizado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao atualizar..",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [updateData]
  );

  const deleteData = useCallback(
    async (id: number) => {
      setLoading(true);
      setFirstData(false);

      inventory
        .deleteInventory(id)
        .then((response) => {
          getData();
          toast({
            title: "Inventário deletado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao deletar..",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [getData]
  );

  // NEW

  const updateParams = (newParams: ParametersPurchaseOrder) => {
    setParamsPurchaseOrderFilter({
      ...paramsPurchaseOrderFilter, // Mantém os valores antigos
      ...newParams, // Atualiza com os novos valores
    });
  };

  const handleSwitchChange = (key: keyof ParametersPurchaseOrder) => {
    setParamsPurchaseOrderFilter((prevParams) => ({
      ...prevParams,
      [key]: !prevParams[key],
    }));
  };

  const handleCheckboxChange = (id: any) => {
    if (idSelectDate.includes(id)) {
      setSelectIds(idSelectDate.filter((selectedId: any) => selectedId !== id));
    } else {
      setSelectIds([...idSelectDate, id]);
    }
  };

  function isEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) {
      return true;
    }

    if (
      typeof obj1 !== "object" ||
      typeof obj2 !== "object" ||
      obj1 === null ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!keys2.includes(key) || !isEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  const handleCheckboxChangeSkus = (id: any, documentId: any) => {
    const selectedObject = { id, documentId };

    if (
      idSelectDateSkus.some((selectedObj: any) =>
        isEqual(selectedObj, selectedObject)
      )
    ) {
      setSelectIdsSkus(
        idSelectDateSkus.filter(
          (selectedObj: any) => !isEqual(selectedObj, selectedObject)
        )
      );
    } else {
      setSelectIdsSkus([...idSelectDateSkus, selectedObject]);
    }
  };

  const handleRemoveCheckboxChangeSkus = () => {
    setSelectIdsSkus([]);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      const allIds = data.map((item) => item.documentId);
      setSelectIds(allIds);
    } else {
      setSelectIds([]);
    }
  };

  const getSkus = useCallback(async () => {
    setLoadingSkus(true);
    setFirstData(false);
    const valueStore = JSON.parse(localStorage.getItem("storeUser"));

    purchase
      .postPurchaseOrders(idSelectDate, valueStore?.value)
      .then((response) => {
        updateDataSkus(response.data?.data);
        setLoadingSkus(false);
      })
      .catch(() => {
        updateDataSkus([]);
        setLoadingSkus(false);
      });
  }, [idSelectDate, updateDataSkus]);

  const handleUpdateWanted = useCallback(
    async (
      index: number,
      documentId: number,
      store: string,
      wanted: number | string
    ) => {
      // debugger;
      const caracteresAceitos = "0123456789";
      const centro = Number(
        store
          .split("")
          .filter((char) => caracteresAceitos.includes(char))
          .join("")
      );

      debugger;
      const purchase = dataSkus.filter(
        (x) =>
          x.productId === index &&
          x.documentId === documentId &&
          x.storeId === centro
      );
      const ind = dataSkus.findIndex(
        (x) =>
          x.productId === index &&
          x.documentId === documentId &&
          x.storeId === centro
      );
      let purchasesSkus = [...dataSkus];
      // if (purchase[0]?.quantityScheduled) {
      // verifica se a propriedade existe
      if (purchase[0] != null) {
        purchase[0] = {
          ...purchase[0],
          quantitySchedule: "",
        };

        purchasesSkus = [...purchasesSkus]; // important to create a copy, otherwise you'll modify state outside of setState call
        purchasesSkus[ind] = purchase[0];
        const newData = purchasesSkus;
        updateDataSkus(newData);
      }
      if (purchase[0].quantityPendingScheduling >= wanted && wanted !== 0) {
        purchase[0] = {
          ...purchase[0],
          quantitySchedule: wanted,
        };
      } else if (wanted === 0) {
        toast({
          title: "Valor não pode ser zero",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        purchase[0] = {
          ...purchase[0],
          quantitySchedule: purchase[0].quantityPendingScheduling,
        };
      } else {
        toast({
          title: "Valor acima da quantidade pedente.",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        purchase[0] = {
          ...purchase[0],
          quantitySchedule: purchase[0].quantityPendingScheduling,
        };
      }
      // }
      setTimeout(() => {
        purchasesSkus = [...purchasesSkus]; // important to create a copy, otherwise you'll modify state outside of setState call
        purchasesSkus[ind] = purchase[0];
        const newData = purchasesSkus;
        updateDataSkus(newData);
      }, 100);

      // updateData((draft) => {
      //   return draft.filter((item) => item.status === 99).concat(newData);
      // });
    },
    [dataSkus, toast, updateDataSkus]
  );
  // Função para transformar array em objeto ou manter o objeto intacto
  function transformarArrayEmObjeto(objetoOuArray: any) {
    // Verifica se é um array
    if (Array.isArray(objetoOuArray)) {
      // Se for um array, transforma em um objeto
      const objetoTransformado = objetoOuArray[0];
      return objetoTransformado;
    } else {
      // Se não for um array, retorna o objeto intacto
      return objetoOuArray;
    }
  }

  // Exemplo de uso
  const objetoOriginal = { id: 1, nome: "Item 1", valor: 10 };
  const arrayOriginal = [
    { id: 1, nome: "Item 1", valor: 10 },
    { id: 2, nome: "Item 2", valor: 20 },
    { id: 3, nome: "Item 3", valor: 30 },
  ];

  const objetoTransformado = transformarArrayEmObjeto(objetoOriginal);

  const arrayTransformado = transformarArrayEmObjeto(arrayOriginal);

  useEffect(() => {
    if (supplierSelect !== null) {
      if (Array.isArray(supplierSelect) && supplierSelect.length === 0) {
        return;
      }
      setLoading(true);
      setFirstData(false);
      setSelectAll(false);
      setSelectIds([]);
      setSelectIdsSkus([]);
      const valueStore = JSON.parse(localStorage.getItem("storeUser"));

      let supplierSelectTransform = transformarArrayEmObjeto(supplierSelect);
      purchase
        .getPurchaseOrders(
          paramsPurchaseOrderFilter,
          valueStore?.value,
          supplierSelectTransform.value
        )
        .then((response) => {
          updateData(response.data?.data);
          setLoading(false);
        })
        .catch(() => {
          updateData([]);
          setLoading(false);
        });
    }
  }, [
    supplierSelect,
    getData,
    paramsPurchaseOrderFilter,
    updateData,
    setSelectAll,
  ]);

  return (
    <SupplierPurchaseContext.Provider
      value={{
        loading,
        data,
        isFirstData,
        suppliers,
        supplierSelect,
        paramsPurchaseOrderFilter,
        idSelectDate,
        selectAll,
        dataSkus,
        idSelectDateSkus,
        loadingSkus,
        query,
        setQuery,
        handleRemoveCheckboxChangeSkus,
        handleUpdateWanted,
        getSkus,
        handleSwitchChange,
        updateParams,
        setSupplierSect,
        getSuppliers,
        getData,
        handleSelectAll,
        deleteData,
        handleCheckboxChange,
        handleCheckboxChangeSkus,
        putData,
        postData,
      }}
    >
      {children}
    </SupplierPurchaseContext.Provider>
  );
};

export default SupplierPurchaseProvider;
export const SupplierPurchaseContext = createContext<ISupplierPurchaseContext>(
  {} as ISupplierPurchaseContext
);
